"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleFooter = void 0;
var React = require("react");
var styles_1 = require("@/pages/articleDetail/components/ArticleFooter/styles");
var AuthorAndShare_1 = require("@/pages/articleDetail/components/AuthorAndShare/AuthorAndShare");
exports.ArticleFooter = function (_a) {
    var newsArticleDetail = _a.newsArticleDetail;
    var data = newsArticleDetail.data, translate = newsArticleDetail.translate;
    var tags = data.tags;
    var renderTags = function () {
        if (tags && tags.length > 0) {
            return (React.createElement(styles_1.TagsContainer, null,
                React.createElement(styles_1.Tags, null, translate.tags + ": "),
                React.createElement(styles_1.TagsHTML, null, tags)));
        }
        return null;
    };
    return (React.createElement(styles_1.Container, null,
        renderTags(),
        React.createElement(styles_1.AuthorAndShareContainer, null,
            React.createElement(AuthorAndShare_1.AuthorAndShare, { newsArticleDetail: newsArticleDetail }))));
};
